import { Link } from 'react-router-dom';
import Seo from '@/components/Seo';

const ShippingPolicyPage = () => {
  return (
    <div className="min-h-screen bg-[#F9F9F7] pb-16" data-testid="shipping-policy-page">
      <Seo title="Shipping & Delivery Policy" description="Bharat Estate is a digital service. Our service-delivery policy explains how membership benefits are activated." path="/shipping-policy" />
      <div className="container-luxury max-w-4xl">
        <div className="bg-white p-8 md:p-12 rounded-sm shadow-sm border border-border/50">
          <h1 className="font-['Plus_Jakarta_Sans'] text-4xl font-bold text-[#0F172A] mb-8">
            Shipping &amp; Delivery Policy
          </h1>
          <p className="text-muted-foreground mb-8">Last updated: February 2026</p>

          <div className="prose prose-lg max-w-none text-[#0F172A]">
            <section className="mb-8">
              <h2 className="font-['Plus_Jakarta_Sans'] text-2xl font-semibold mb-4">1. Nature of Services</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Bharat Estate is an online real estate listing platform.
                We do not sell, ship, or deliver any physical goods. The platform offers digital services
                only — including, but not limited to, property listings, premium membership subscriptions,
                EMI calculators, owner contact reveals (connects), and related digital tools.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-['Plus_Jakarta_Sans'] text-2xl font-semibold mb-4">2. Digital Service Delivery</h2>
              <ul className="list-disc list-inside text-muted-foreground space-y-2 mb-4">
                <li>
                  <strong>Premium Membership:</strong> Activated <strong>instantly</strong> upon successful
                  payment confirmation from our payment processor (Stripe). Your listing and connect quotas
                  are credited to your account within seconds.
                </li>
                <li>
                  <strong>Listings &amp; Connects:</strong> Available immediately on your dashboard once a
                  premium plan is active.
                </li>
                <li>
                  <strong>Receipts &amp; Invoices:</strong> Auto-generated and emailed to your registered
                  email address within 24 hours of payment.
                </li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-['Plus_Jakarta_Sans'] text-2xl font-semibold mb-4">3. Activation Timelines</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                In rare cases, due to network issues or payment gateway delays, activation may take up to
                <strong> 30 minutes</strong>. If your account is not upgraded after this period, please contact
                support at <a href="mailto:contact@bharat.estate" className="text-[#D4AF37] hover:underline">contact@bharat.estate</a>
                {' '}with your payment reference and registered email.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-['Plus_Jakarta_Sans'] text-2xl font-semibold mb-4">4. No Physical Shipment</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                Bharat Estate does not dispatch any physical product. Property visits, site inspections, and
                ownership transfers are arranged directly between buyers, sellers, and tenants and are not
                facilitated, shipped, or delivered by Bharat Estate.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-['Plus_Jakarta_Sans'] text-2xl font-semibold mb-4">5. Failed Activation &amp; Support</h2>
              <p className="text-muted-foreground leading-relaxed mb-4">
                If a payment is debited from your account but your premium plan is not activated, you may
                request resolution by contacting support within 7 days. Verified failed activations will be
                resolved either by activating the plan or, where applicable, by initiating a chargeback as per
                our <Link to="/refund-policy" className="text-[#D4AF37] hover:underline">Refund &amp; Cancellation Policy</Link>.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-['Plus_Jakarta_Sans'] text-2xl font-semibold mb-4">6. Contact</h2>
              <p className="text-muted-foreground leading-relaxed">
                For any queries related to digital service delivery, please reach out to:
              </p>
              <p className="text-muted-foreground leading-relaxed mt-3">
                <strong>Bharat Estate</strong><br />
                Email: <a href="mailto:contact@bharat.estate" className="text-[#D4AF37] hover:underline">contact@bharat.estate</a><br />
                Phone: +91 94650 24516
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicyPage;
